import { combineReducers } from 'redux';
import { notificationsDeleteSlice } from './@async/delete';
import { notificationsGetSlice } from './@async/get';
import { notificationsPatchSlice } from './@async/patch';
import { removeNotifications } from './@sync/remove';
import { removeNotificationsById } from './_id/@sync/remove';
import { updateNotifications } from './@sync/update';
import { updateNotificationsById } from './_id/@sync/update';
import { combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { notificationsByIdReducers, watchNotificationsByIdSagas } from './_id';

export const notificationsReducers = combineReducers({
	byId: notificationsByIdReducers,
	delete: notificationsDeleteSlice.asyncReducers,
	get: joinCollectionReducers([
		notificationsGetSlice.asyncReducers,
		updateNotifications.syncReducer,
		updateNotificationsById.syncReducer,
		removeNotifications.syncReducer,
		removeNotificationsById.syncReducer
	], notificationsGetSlice.asyncState),
	patch: notificationsPatchSlice.asyncReducers
});

export const watchNotificationsSagas = combineAllWatchers([
	watchNotificationsByIdSagas,
	notificationsDeleteSlice.asyncWatchers,
	notificationsGetSlice.asyncWatchers,
	notificationsPatchSlice.asyncWatchers
]);
